import React from 'react';
import Helmet from 'react-helmet';

var SEO = function SEO(props) {
  var contentMetaData = props.contentMetaData || {};
  var integratorData = props.integratorData || {};
  var defaultSiteData = props.defaultSiteData || {};
  var lang = contentMetaData && contentMetaData.lang || defaultSiteData.lang || "en";
  var title = contentMetaData && contentMetaData.seoTitle || defaultSiteData.seoTitle || "";
  var siteTitle = integratorData && integratorData.siteID && integratorData.siteID.name ? integratorData.siteID.name : defaultSiteData.siteName ? defaultSiteData.siteName : "";
  var siteURL = integratorData && integratorData.siteID && integratorData.siteID.url ? integratorData.siteID.url : defaultSiteData.siteURL ? defaultSiteData.siteURL : "";
  var metaDescription = contentMetaData && contentMetaData.metaDescription || defaultSiteData.metaDescription || "";
  var author = contentMetaData && contentMetaData.createdByName || defaultSiteData.author || "";
  var allowFollowing = contentMetaData && contentMetaData.allowFollowing || true;
  var allowIndexing = contentMetaData && contentMetaData.allowIndexing || true;
  var featuredImage = contentMetaData && contentMetaData.featuredImage || defaultSiteData.featuredImage || "";
  contentMetaData && contentMetaData.socialFacebookDescription || metaDescription || "";
  contentMetaData && contentMetaData.socialFacebookTitle || title || "";
  contentMetaData && contentMetaData.socialFacebookImage || featuredImage || "";
  var socialTwitterDescription = contentMetaData && contentMetaData.socialTwitterDescription || metaDescription || "";
  var socialTwitterTitle = contentMetaData && contentMetaData.socialTwitterTitle || title || "";
  var socialTwitterImage = contentMetaData && contentMetaData.socialFacebookImage || featuredImage || "";
  var meta = [];

  if (!allowFollowing && !allowIndexing) {
    meta.push({
      name: "robots",
      content: "noindex,nofollow"
    });
  } else if (!allowFollowing && allowIndexing) {
    meta.push({
      name: "robots",
      content: "nofollow"
    });
  } else if (allowFollowing && !allowIndexing) {
    meta.push({
      name: "robots",
      content: "noindex"
    });
  }

  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: lang
    },
    title: title,
    titleTemplate: "%s | ".concat(siteTitle),
    meta: [{
      name: "description",
      content: metaDescription
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: metaDescription
    }, {
      property: "og:type",
      content: "website"
    }, {
      property: "og:url",
      content: siteURL
    }, {
      property: "og:image",
      content: featuredImage
    }, {
      property: "og:site_name",
      content: siteTitle
    }, {
      name: "subject",
      content: metaDescription
    }, {
      name: "twitter:card",
      content: "summary"
    }, {
      name: "twitter:creator",
      content: author
    }, {
      name: "twitter:title",
      content: socialTwitterTitle
    }, {
      name: "twitter:description",
      content: socialTwitterDescription
    }, {
      name: "twitter:image",
      content: socialTwitterImage
    }].concat(meta)
  });
};

export default SEO;